export const SHOW_INFO= 'show-info'
export const HIDE_INFO= 'hide-info'


export type typeActions = typeof SHOW_INFO | typeof HIDE_INFO

